// src/api/apiService.js
import axios from "./AxiosInstance";
import { toast } from "react-toastify";

const handleError = (error, showToast = true) => {
  let message;

  if (error.response) {
    message =
      error.response.data?.message ||
      error.response.data?.title ||
      "An error occurred while processing your request.";
  } else {
    message = error.message || "Something went wrong.";
  }

  if (showToast) toast.error(message);
  throw error;
};

// 🔄 No need for withCredentials anymore
const createOptions = (customOptions = {}) => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("accessToken") || ""}`,
    ...(customOptions.headers || {})
  },
  ...customOptions,
});

const apiService = {
  getWithParams: async (resource, params, showToast = true) => {
    try {
      const res = await axios.get(`/${resource}`, createOptions({ params }));
      return res.data;
    } catch (error) {
      handleError(error, showToast);
    }
  },

  getAll: async (resource, showToast = true) => {
    try {
      const res = await axios.get(`/${resource}`, createOptions());
      return res.data;
    } catch (error) {
      handleError(error, showToast);
    }
  },

  get: async (resource, pageSize, pageNumber, showToast = true) => {
    try {
      const res = await axios.get(`/${resource}?pageSize=${pageSize}&pageNumber=${pageNumber}`, createOptions());
      return res.data;
    } catch (error) {
      handleError(error, showToast);
    }
  },

  getById: async (resource, id, showToast = true) => {
    try {
      const res = await axios.get(`/${resource}/${id}`, createOptions());
      return res.data;
    } catch (error) {
      handleError(error, showToast);
    }
  },

  getSingle: async (resource, showToast = true) => {
    try {
      const res = await axios.get(`/${resource}`, createOptions());
      return res.data;
    } catch (error) {
      handleError(error, showToast);
    }
  },

  create: async (resource, data, showToast = true) => {
    try {
      const res = await axios.post(`/${resource}`, data, createOptions());
      if (showToast) toast.success("Created successfully");
      return res.data;
    } catch (error) {
      handleError(error, showToast);
    }
  },

  post: async (resource, data = {}, showToast = true) => {
    try {
      const res = await axios.post(`/${resource}`, data, createOptions());
      return res.data;
    } catch (error) {
      handleError(error, showToast);
    }
  },

  update: async (resource, data, showToast = true) => {
    try {
      const res = await axios.put(`/${resource}`, data, createOptions());
      if (showToast) toast.success("Updated successfully");
      return res.data;
    } catch (error) {
      handleError(error, showToast);
    }
  },

  remove: async (resource, id, showToast = true) => {
    try {
      const res = await axios.delete(`/${resource}/${id}`, createOptions());
      if (showToast) toast.success("Deleted successfully");
      return res.data;
    } catch (error) {
      handleError(error, showToast);
    }
  },
};

export default apiService;